<template>
  <div>
    <b-card style="margin:20px" class="ma-3">
     
        <b-row>
          <b-col cols="2" style="width:300px">
            <Sidebar></Sidebar>
          </b-col>
           <div class="mr-1" style="border:solid;width:1px"></div>
             <b-col cols="1"></b-col>
          <b-col cols="6">
            
            <div>
              <div>
                <div>
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols-sm="4"
                    label-cols-lg="3"
                    label="User Role"
                  >
                    <b-form-select v-model="selected" :options="options"></b-form-select>
                  </b-form-group>
                </div>
                <div>
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols-sm="4"
                    label-cols-lg="3"
                    label="Tasks/Areas Accessible"
                  >
                  
                         <b-form-checkbox  style="display: table;"
      id="checkbox-1"
      v-model="status1"
      name="checkbox-1"
      value="accepted"
      unchecked-value="not_accepted"
    >
      View Client Profile/Task	01

    </b-form-checkbox>

       <b-form-checkbox style="display: table;"
      id="checkbox-2"
      v-model="status2"
      name="checkbox-2"
      value="accepted"
      unchecked-value="not_accepted"
    >
     Create User Roles/Task	02
    </b-form-checkbox>

       <b-form-checkbox style="display: table;"
      id="checkbox-3"
      v-model="status3"
      name="checkbox-3"
      value="accepted"
      unchecked-value="not_accepted"
    >
     Create	Users/Task	03
    </b-form-checkbox>
                  
                  </b-form-group>
                </div>
              <br>
                <div>
                  <b-button variant="primary">Submit</b-button>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
    
    </b-card>
  </div>
</template>

<script>
import Sidebar from "../AdminSlidebar";

export default {
  name: "AdminAddUser",
  components: {
    Sidebar
  },
  data() {
    return {
      options: [
        { value: "A", text: "Admin " },
        { value: "B", text: "role 01 " },
        { value: "c", text: "role 02 " }
      ],
      status1: "not_accepted",
      status2: "not_accepted",
      status3: "not_accepted"
    };
  }
};
</script>

<style>
</style>